<template>
  <div class="card">
    <div class="card-body">
      <div
        v-if="icon"
        class="text-center pb-3"
      >
        <img
          :src="iconUrl"
          style="width: 80px; height: 80px"
        >
      </div>
      <div class="d-flex justify-content-between">
        <div class="flex-grow-1">
          <h5 class="card-title">
            {{ name }}
          </h5>
        </div>
        <div class="text-success stars">
          <span
            v-for="s in stars"
            :key="s"
          >*</span>
        </div>
      </div>
      <div>
        <ul class="req-list">
          <li
            v-for="(req, i) in requirements"
            :key="i"
          >
            {{ req }}
          </li>
        </ul>
      </div>
      <div
        v-if="editable"
        class="text-right pt-1"
      >
        <button
          class="btn btn-sm btn-outline-secondary icon-button mr-3"
          @click="$emit('remove')"
        >
          <i class="ion ion-md-trash" />
        </button>
        <button
          v-if="!editing"
          class="btn btn-sm btn-outline-secondary icon-button"
          @click="$emit('edit')"
        >
          <i class="ion ion-md-create" />
        </button>
        <span
          v-else
          class="text-success"
          style="font-size: 23px; line-height: 0"
        >
          <i class="ion ion-md-arrow-back" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    name: String,
    stars: Number,
    icon: String,
    requirements: Array,
    editing: Boolean,
    editable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    iconUrl() {
      if (!this.icon) return null;
      if (this.icon.startsWith('data')) return this.icon;
      return `${process.env.VUE_APP_AUTH_API}/img/form/${this.icon}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .stars {
    font-weight: bold;
    font-size: 20px;
    margin-top: -3px;
  }
  .req-list {
    font-size: 14px;
    padding-inline-start: 25px;
    margin-bottom: 0;
  }
</style>
